import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/course-agenda-calendar-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type CourseAgendaCalendarStore = {
    course: Map<unknown, unknown>;
};

const initialState = (): CourseAgendaCalendarStore => {
    return {
        course: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<CourseAgendaCalendarStore> = {
    [actionTypes.GET_COURSE_SUCCESS]: (state, action) => {
        return {
            course: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseAgendaCalendarStore>(initialState(), actionsMap);
